module.exports = "../study/imgs/maps/Kanagawa/S8/Ecosystem/Avietchii/Kanagawa_Avietchii_MRI_RCP45_Mid.png";